/* esm.sh - varuint-bitcoin@2.0.0 */
export * from "/*varuint-bitcoin@2.0.0/esnext/varuint-bitcoin.mjs";
